import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useState } from 'react'
function Product_individual_data() {
  const {id} = useParams()
  const [product, setProduct] = useState({})
  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL+`/api/products/${id}`)
    .then(response => {
      setProduct(response.data)
    }
    )
    .catch(error => {
      console.log(error)
    });
  });
  const HandleClickedit = (pdtid) => {
    console.log(pdtid);
    window.location.href = `/Products/editForm/${pdtid}`;
  };
  // const HandleClickview = (pdtid) => {
  //   console.log(pdtid);
  //   window.location.href = `/Products/viewCard/${pdtid}`;
  // };
  const HandleClickdelete = (pdtid) => {
    console.log(pdtid);
    axios
      .delete(process.env.REACT_APP_API_URL+`/api/DeleteProducts/${pdtid}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        window.location.href = "/Products";
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <div className="flex justify-between p-2 bg-gray-200 rounded-lg mb-2">
        <input
          type="text"
          placeholder="Search By Name"
          className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md w-96"
        ></input>
      </div>
      <section className="mx-auto w-full max-w-7xl px-4 py-4">
        <div className="flex flex-col space-y-4 md:flex-row md:products-center md:justify-between md:space-y-0">
          <div>
            <h2 className="text-lg font-semibold">Products</h2>
          </div>
          
        </div>
        <div className="mt-6 flex flex-col">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden border border-gray-200 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr className="divide-x divide-gray-200 productstr-data">
                      <th
                        scope="col"
                        className="w-1/12 px-2 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        <span>Product</span>
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-6 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Categery / Discription
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Stock
                      </th>
                      <th
                        scope="col"
                        className=" w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500"
                      >
                        Price / MRP (Per KG)
                      </th>
                      <th scope="col" className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500">
                        Status
                      </th>
                      <th
                        scope="col"
                        className="w-1/12 px-4 py-3.5 text-left text-sm font-normal text-gray-500" >
                        </th>
                    </tr>
                  </thead>
                  <tbody
                        className="divide-y divide-gray-200 bg-white productstr-data"
                  >
<tr className="divide-x divide-gray-200 ">
                          <td className="whitespace-nowrap px-4 py-4">
                            <div className="flex products-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img
                                  className="h-10 w-10 rounded-full object-cover"
                                  src={product.img}
                                  alt=""
                                />
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-gray-900">
                                  {product.name}
                                </div>
                                <div className="text-sm text-gray-500">
                                  {product.brand}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-12 py-4">
                            <div className="text-sm text-gray-900">
                              {product.category}
                            </div>
                            <div className="text-sm text-gray-500">
                              {product.description}
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-4 py-4">
                            <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                              {product.stock} available
                            </span>
                          </td>
                          <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-500">
                            {product.price} / {product.mrp}
                          </td> 
                          
                          <td className="whitespace-nowrap px-4 py-4 text-left text-sm font-medium">
                               {product.isActive ? (
                                 <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                                   Active
                                 </span>
                               ) : (
                                 <span className="inline-flex rounded-full bg-gray-300 px-2 text-xs font-semibold leading-5 text-gray-800">
                                   Disabled
                                 </span>
                               )}
</td>
                          <td className="whitespace-nowrap px-4 py-4 text-right text-sm font-medium">
                            <button onClick={()=>HandleClickedit(product.id)} className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"> Edit</button>
                            <button onClick={()=>HandleClickdelete(product.id)} className="ml-3 rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"> Delete</button>
                          </td>
                        </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Product_individual_data